import { render, staticRenderFns } from "./ModerationSection.vue?vue&type=template&id=5ff4e01c"
import script from "./ModerationSection.vue?vue&type=script&lang=js"
export * from "./ModerationSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports